import { useEffect, useState } from "react";
import { useAuth } from "swyft-react-core";
import { GetClientConfig, GetPublicConfig } from "../../api/SwyftApi";
import { ServerConfig } from "../../api/Types";
import { Loader } from "../loader";
import { ConfigContext } from "./ConfigContext";

export const ConfigProvider: React.FC = ({ children }) => {
  const [config, setConfig] = useState<ServerConfig | null>(null);

  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    const fn = () => {
      if (isLoading) {
        return;
      }
      if (isAuthenticated) {
        GetClientConfig().then((x) => setConfig(x));
      } else {
        GetPublicConfig().then((x) => setConfig(x));
      }
    };

    fn();
  }, [isAuthenticated, isLoading]);

  const serviceConfig = () => {
    return config!.services.find((x) => x.name === "Store");
  };

  const isFeatureEnabled = (featureName: string) => {
    return serviceConfig()?.features.some((x) => x.name === featureName && x.enabled === true) ?? false;
  };

  const getFeatureConfig = (featureName: string) => {
    return serviceConfig()?.features.find((x) => x.name === featureName)?.featureConfig;
  };

  const getFeatureConfigValue = (featureName: string, configValueName: string) => {
    return getFeatureConfig(featureName)?.[configValueName];
  };

  if (config == null) {
    return <Loader />;
  }

  return (
    <ConfigContext.Provider
      value={{
        config,
        isFeatureEnabled,
        getFeatureConfig,
        getFeatureConfigValue
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
